// src/hooks/useAppVersions.js
import { useState, useEffect, useCallback, useMemo } from 'react';
import { appVersionService } from '../services/appVersionService';

export function useAppVersions() {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await appVersionService.listVersions();
      setVersions(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // agrupa por runtime_version → cada grupo = 1 build de loja + OTAs sobre ele.
  // preserva a ordem do back (mais recentes primeiro).
  const groups = useMemo(() => {
    const map = new Map();
    for (const v of versions) {
      const key = v.runtime_version ?? '—';
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(v);
    }
    return Array.from(map.entries()).map(([runtimeVersion, items]) => ({
      runtimeVersion,
      // a store do grupo é o item de channel "store"; pode não existir ainda
      storeVersion: items.find((i) => i.channel === 'store')?.version ?? null,
      items,
    }));
  }, [versions]);

  // --- utilitários pro form (tarefa [8]) ---

  // true se já existe (platform, version) — evita duplicada antes do POST
  const versionExists = useCallback(
    (platform, version) =>
      versions.some(
        (v) => v.platform === platform && v.version === version
      ),
    [versions]
  );

  return {
    versions,
    groups,
    loading,
    error,
    reload: load,
    versionExists,
  };
}